import { Color } from '@/models/entities/Color';
import { ImageFile } from '@/models/entities/ImageFile';

export class Location {
  public id: number = 0;
  public name: string = '';
  public imageFile: ImageFile = new ImageFile({});

  constructor(initData: Partial<Location>) {
    Object.assign(this, initData);
  }
}

export class ColorizableArea {
  public id: number = 0;
  public name: string = '';
  public query: string = '';
  public colors: Color[] = [];
  public location?: {
    id: Location['id'];
    name: Location['name'];
  };

  constructor(initData: Partial<Location>) {
    Object.assign(this, initData);
  }
}
